/**
 * GET DASHBOARD METRICS
 */

export const GET_DASHBOARD_METRICS_REQUEST = "GET_DASHBOARD_METRICS_REQUEST";
export const GET_DASHBOARD_METRICS_SUCCESS = "GET_DASHBOARD_METRICS_SUCCESS";

